import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * PDP hero card image that follows the selected variant.
 * Listens for Horizon's productSelect event and morphs in the freshly
 * rendered image from the section HTML (same pattern as product-inventory).
 *
 * @extends {Component<Record<string, never>>}
 */
class ApVariantImage extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Handles product select by swapping in the new variant's image.
   * @param {ProductSelectEvent} event
   */
  #handleProductSelect = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    try {
      const { detail } = await event.promise;
      if (!detail?.html) return;

      const { html, newProduct, productId } = detail;

      if (newProduct) {
        this.dataset.productId = newProduct.id;
      } else if (productId && productId !== this.dataset.productId) {
        return;
      }

      const newEl = html.querySelector(`ap-variant-image[data-block-id="${this.dataset.blockId}"]`);
      if (!newEl) return;

      morph(this, newEl, { childrenOnly: true });
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[ap-variant-image] Event promise rejected:', error);
    }
  };
}

if (!customElements.get('ap-variant-image')) {
  customElements.define('ap-variant-image', ApVariantImage);
}
